import React from "react";

class GameReleasedTitle extends React.Component
{
    render()
    {
        return(
            <div id="game_releasedTitle">
                Game Released
            </div>
        );
    }
}
export default GameReleasedTitle;